// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import useSearch from "@store/Framework/Common/Hooks/useSearch";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import React from "react";
import { css } from "styled-components";

interface SearchBoxProps {
    onSearch: (searchTerm: string) => void;
    placeholder?: string;
    title?: string;
    disabled?: boolean;
    extendedStyles?: SearchBoxStyles;
    debounce?: number;
    dataTestSelector?: string;
}

export interface SearchBoxStyles {
    gridItem?: GridItemProps;
    textField?: TextFieldProps;
}

const searchBoxStyles: SearchBoxStyles = {
    gridItem: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
        width: 12,
    },
    textField: {
        ...searchInputStyles.input,
        cssOverrides: {
            ...searchInputStyles?.input?.cssOverrides,
            formField: css`
                padding-inline: 0;
            `,
            inputSelect: css`
                ${searchInputStyles.input?.cssOverrides?.inputSelect}
                border-radius: ${({ theme }) => theme.design.radius.medium};
            `,
        },
    },
};

const SearchBox: React.FC<SearchBoxProps> = ({
    onSearch,
    placeholder,
    disabled = false,
    title = translate("Search"),
    extendedStyles,
    dataTestSelector,
}) => {
    const styles = useMergeProps(searchBoxStyles, extendedStyles);
    const [searchTerm, setSearchTerm] = useSearch(onSearch, 0);
    return (
        <GridItem {...styles.gridItem}>
            <TextField
                disabled={disabled}
                type="search"
                label={title}
                value={searchTerm}
                {...searchInputStyles.input}
                onChange={event => setSearchTerm(event?.target?.value || "")}
                border="rounded"
                placeholder={placeholder}
                {...styles.textField}
                data-test-selector={dataTestSelector}
            />
        </GridItem>
    );
};

export default SearchBox;
